const isValidPhone = (phone) => {
  let regex = new RegExp(/^\+\d{1,3}\s?\d+$/);
  return regex.test(phone);
};

const isValidPostCode = (value) => {
  let regex = new RegExp(/[0-9]{4}/);
  return regex.test(value);
};

/**
 * @TODO - No control regular expressions & remove the eslint rule disabler.
 * This can be greatly simplified using binary-tree filtration.
 */
const isValidEmail = (email) => {
  let regex = new RegExp(
    // eslint-disable-next-line no-control-regex
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  );

  return regex.test(email);
};

export { isValidPhone, isValidEmail, isValidPostCode };
